// removed by extract-text-webpack-plugin
module.exports = {"email":"PasswordReset__email___X7dx7","login":"PasswordReset__login___3QSlL","logo":"PasswordReset__logo___2Y2t8"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/PasswordReset/components/PasswordReset.scss
// module id = 1216
// module chunks = 1